// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qMov9","title":"styles_title__KJx8e","buttons":"styles_buttons__ccOs6"};